/** Existing save handlers use false for failure; commands may provide precise feedback. */
export function saveFeedbackOutcome(result, danish) {
  if (result?.feedback && typeof result.feedback.success === 'boolean' && typeof result.feedback.message === 'string' && result.feedback.message.trim()) {
    return result.feedback;
  }
  const success = result !== false;
  return {success, message: success
    ? (danish ? 'Indstillingen er opdateret' : 'Setting updated')
    : (danish ? 'Indstillingen kunne ikke gemmes' : 'The setting could not be saved')};
}
